/* Log to the console as long as not the production environment */
export default function logIfNotProduction(message) {
  if (process.env.NODE_ENV !== "production") {
    console.log(message);
  }
}
